(ns dre.components.backdrop
  (:require
   [applied-science.js-interop :as j] 
   [reagent.core :as reagent]))


(defn backdrop
  [_content _opts]
  (reagent/create-class
    {:display-name "backdrop"

     :component-did-mount
     #(js/window.document.body.classList.add "with-backdrop")

     :component-will-unmount
     #(js/window.document.body.classList.remove "with-backdrop")

     :reagent-render
     (fn [content {:keys [on-outside-click] :as opts}]
       [:<>
        [:div.backdrop]
        [:div.backdrop__content
         {:on-click (fn [e] 
                      (when (and on-outside-click
                                 (or 
                                  (.contains (j/get (.-target e) :classList) "modal__content") ;;hacky way to fix modal outside click
                                  (.contains (j/get (.-target e) :classList) "backdrop__content")))
                        (on-outside-click)))}
         content]])}))
